import React, { useState } from "react";
import { NavDropdown } from "react-bootstrap";

// This component is a menu collection of actions related to adjusting the side of the
// Ag-Grid's table or columns.
function SizeSelector(props) {
  const { gridColumnApi, setTableStyle, initialHeight } = props;
  const [colSize, setColSize] = useState(150);
  const [height, setHeight] = useState(initialHeight);
  const [skipHeader] = useState(false);

  const updateColsSize = (event) => {
    event.preventDefault();
    const columnWidths = [];
    gridColumnApi.getAllColumns().forEach(function (column) {
      columnWidths.push({ key: column.colId, newWidth: colSize });
    });
    gridColumnApi.setColumnWidths(columnWidths);
  };

  const autoSizeAll = (event) => {
    event.preventDefault();
    const allColumnIds = [];
    gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  };

  const resetColsSize = (event) => {
    event.preventDefault();
    gridColumnApi.resetColumnState();
  };

  const onChangeHeight = (event) => {
    event.preventDefault();
    setTableStyle({ height });
  };

  return (
    <NavDropdown title="Size" id={"nav-bar-size"}>
      <NavDropdown.Item onClick={autoSizeAll}>
        Set columns' width to fit content
      </NavDropdown.Item>
      <NavDropdown.Item onClick={updateColsSize} style={{ display: "inline" }}>
        Set columns' width to
      </NavDropdown.Item>
      <input
        type={"number"}
        id={"col-size-input"}
        value={colSize}
        onChange={(e) => setColSize(Number(e.target.value))}
        min={80}
        style={{ width: "3rem" }}
        onClick={(e) => e.preventDefault()}
      />
      <NavDropdown.Item onClick={resetColsSize}>
        Reset columns' width
      </NavDropdown.Item>
      <NavDropdown.Divider />
      <NavDropdown.Item onClick={onChangeHeight} style={{ display: "inline" }}>
        Set table's height to
      </NavDropdown.Item>
      <input
        style={{
          width: "3rem",
        }}
        type="number"
        min="100"
        id="table-height-input"
        value={height}
        onChange={(e) => setHeight(Number(e.target.value))}
      />
    </NavDropdown>
  );
}

export default SizeSelector;
